import cuid from 'cuid';
export function id(short) {
    if (short)
        return cuid.slug();
    return cuid();
}
//# sourceMappingURL=id.js.map